import { pageData } from "../../constants/pagedata";
import { capitalizeFirst } from "../../utils/utils";
import { ALL_GAMES_LIST } from "../../constants/textcontent";
import { PagePicker } from "../../components/pagepicker";

export const StepOne=function(props:{resetClick:() => void, createStarted:boolean,pageSelected:string, pageClick:(page: string) => void}){
	let infoText='Choose a page';
	if(props.pageSelected!==''&&pageData[props.pageSelected].pageDir!==undefined){
		infoText='Page chosen: '+capitalizeFirst(pageData[props.pageSelected].pageDir.replace(/-/g,' '));
	}
	let myShowList=ALL_GAMES_LIST;
	let isComplete=props.pageSelected!=='';
	return(
		<div className='teachers-taskcreater-step'>
            {props.createStarted&&<button onClick={()=>{props.resetClick();}} className='teachers-taskcreater-button teachers-button'>Create New Task</button>}
			<h3>Step 1{isComplete&&'  - Complete'}</h3>
			<p>{infoText}</p>
			<PagePicker
				pageClick={props.pageClick} 
				pageSelected={props.pageSelected}
				showList={myShowList} />
		</div>
	)
};